module.exports = __webpack_public_path__ + "img/icone-pizzaria.15b3412d.svg";